import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import filterValidProps from './filterValidProps';
import { mergeProps } from './mergeProps';
export var domProps = function domProps(props) {
  for (var _len = arguments.length, styledExpressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    styledExpressions[_key - 1] = arguments[_key];
  }
  return filterValidProps(mergeProps.apply(void 0, [props].concat(_toConsumableArray(styledExpressions.map(function (r) {
    return {
      className: r.className
    };
  })))));
};